import moment from 'moment';
import { AssetItemDto, AssetVersionItemDto } from '@api/Api';
import { getMediaDuration, getVideoFrameRate } from '@helpers/avInfo';
import { formatDuration } from '@helpers/formatDuration';
import { bytesToSize } from '@helpers/bytesToSize';

type TDataItem = {
  label: string;
  value: string | number | null;
};

function getDate(date: string) {
  return moment(new Date(date)).format(
    moment(date).minutes() === 59 ? 'MMM Do' : 'MMM Do [at] h:mm a'
  );
}

export function formatDetails({
  assets,
  selectedVersion
}: {
  assets: AssetItemDto | null;
  selectedVersion: AssetVersionItemDto | null;
}): TDataItem[] {
  if (!selectedVersion) return [];
  const { metadata } = selectedVersion;
  const res: TDataItem[] = [];
  res.push({
    label: 'File Name',
    value: `${selectedVersion.name}.${selectedVersion.extension}`
  });
  if (assets?.owner?.user) {
    res.push({
      label: 'Asset Owner',
      value: assets?.owner?.user.name
    });
  }
  res.push({
    label: 'Upload date',
    value: getDate(selectedVersion.createdAt)
  });
  res.push({
    label: 'Size',
    value: bytesToSize({ bytes: selectedVersion.size })
  });
  if (metadata) {
    if (metadata.type === 'video') {
      const { avInfo } = metadata.info;
      if (avInfo?.video?.width && avInfo?.video?.height) {
        res.push({
          label: 'RES',
          value: `${avInfo.video.width} x ${avInfo.video.height}`
        });
      }
      const duration = getMediaDuration(metadata);
      if (duration) {
        res.push({
          label: 'Duration',
          value: formatDuration(duration)
        });
      }
      const frameRate = getVideoFrameRate(metadata);
      if (frameRate !== undefined) {
        res.push({
          label: 'FPS',
          value: frameRate.toFixed(3)
        });
      }
      if (avInfo?.video?.codecName) {
        res.push({
          label: 'Codec',
          value: avInfo.video.codecName
        });
      }

      if (avInfo?.audio?.codecName) {
        res.push({
          label: 'Audio',
          value: avInfo?.audio?.codecName?.toLocaleUpperCase() || ''
        });
      }
    }
    if (
      metadata.type === 'raster_image' ||
      metadata.type === 'camera_raw_image' ||
      metadata.type === 'vector_image'
    ) {
      const { imageInfo } = metadata.info;
      if (imageInfo?.width && imageInfo?.height) {
        res.push({
          label: 'RES',
          value: `${imageInfo.width} x ${imageInfo.height}`
        });
      }
    }
  }
  return res;
}
